import { network } from './network';

export async function getCreditsList(opts) {
	const res = await network({
		url: '/api/v1/credits/list',
		method: 'post',
		params: {
			page: opts.page,
			page_size: 20,
			expired: opts.expired
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}


export async function getBoostCards(opts) {
	const res = await network({
		url: '/api/v1/credits/boost_cards',
		method: 'post',
		params: {
			page: opts.page,
			page_size: 10,
		},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
